import { css } from 'linaria';

export const productInfoServices = css`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const productInfoServiceWrapper = css`
  display: flex;
  align-items: center;
  flex-basis: content;
  padding: 12px;
  column-gap: 16px;
  background-color: #d3f0f3;
  border-radius: var(--rounding-l);
`;

export const productInfoServicePriceWrapper = css`
  padding: 10px 20px;
  margin-left: auto;
  background-color: var(--background-primary);
  border-radius: var(--rounding-l);

  @media (--only-mobile) {
    padding: 6px 12px;
  }
`;
